/* eslint-disable no-unsafe-optional-chaining */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import './reviewProfile.css';
import Pagination from '@mui/material/Pagination';
import { useParams } from 'react-router-dom';
import { AiOutlineCalendar } from 'react-icons/ai';
import BannerImage from './BannerImage';
import ProgressBar from './ProgressBar';
import ReviewList from './ReviewList';
import Address from './Address';
import RequestAppointmentForm from './RequestAppointmentForm';
import ReviewTab from './ReviewTab';
import Loader from '../../Loader';
import ReviewSummary from './ReviewSummary';
import RequestAppointment from './RequestAppointment';
import About from './About';
import SimpleModal from './SimpleModal';
import AboutSalesCap from './AboutSalesCap';
import SelfDescription from './SelfDescription';

const ReviewProfile = ({ baseURL }) => {
  const { companyid } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState(null);
  const [currentPage,setCurrentPage] = useState(1);
  const [currentGooglePage,setCurrentGooglePage] = useState(null);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [openPopup,setPopup] = useState(false);
  const [newReviews, setNewReviews] = useState();
  const [newData,setNewData] = useState();
  const [googleData,setGoogleData] = useState(null);
  const [page,setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    getReviewProfile();    
    allReviews();
  }, []);

  useEffect(() => {
    salescaptainReviews();
  },[page]);

  const getReviewProfile = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/dashboard-review/review-profile/${companyid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });
      if (response?.data?.status === 'success') {
        setData(response?.data?.data?.entity);
        setLoading(false);
      }
      console.log(response, 'getReviewProfile res');
    } catch (err) {
      // console.log('getReviewProfile err', err);
    }
  };
  // console.log(data,'no hello');
  // console.log(selectedTab,'tab');

  // Get current post
  //  const indexOfLastPost = currentPage * postsPerPage;
  //  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  //  const currentPosts = data?.reviews?.slice(indexOfFirstPost,indexOfLastPost);

  // console.log( currentPosts,"hi there")

  // const paginate =(pageNumber)=>setCurrentPage(pageNumber);

  const salescaptainReviews = async () => {
  // const newArray = reviews.filter((e) => e.reviewReply.reply.length === 0);
  // setNewReviews(newArray);

    try {
      const responseNewReview = await axios.get(`${baseURL}/dashboard-review/get-all-reviews-dashboard/${companyid}?page=${page}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });
    
      // console.log(responseNewReview,'NewReview');
      setNewData(responseNewReview?.data?.data?.data);
      setCurrentPage(responseNewReview?.data?.data?.currentPage);
      setTotalPages(responseNewReview?.data?.data?.totalPages);
      // console.log(currentPage,'Current Review Page');
      // console.log(newData,'new review');
    } catch (err) {
      // console.log('newReview err', err);
    }
  };

  const allReviews = async () => {
  // setNewReviews();

    try {
      const responseGoogleReview = await axios.get(`${baseURL}/dashboard-review/get-all-google-reviews/${companyid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });

      // console.log(responseGoogleReview,'new google review');
      setGoogleData(responseGoogleReview?.data?.data);
      // console.log(googleData,'Google Data');
      setCurrentGooglePage(googleData?.currentPage);
      // console.log(currentGooglePage,'page google');
    } catch (err) {
      console.log('googleData err', err);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="flex min-h-screen w-full justify-center bg-slate-50 px-3 py-4 sm:px-6 sm:py-8">
      <div className="qs-fade-in w-full max-w-6xl space-y-5">
        <div className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200">
          <div>
            {data && data.cover_photo_url !== null && data.cover_photo_url !== '' && (
            <BannerImage data={data} />
            )}
          </div>
          <div>
            {data && (
            <Address data={data} />   
            )}
          </div>
        </div>

        <div className="w-full gap-5 pb-8 lg:flex">
          <div className="mb-5 w-full min-w-0 space-y-5 lg:mb-0 lg:w-[68%]">
            <div className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200">
              {data && (
                <ReviewSummary data={data} />   
              )}
            </div>
            <div className="overflow-hidden rounded-2xl bg-white pb-6 shadow-sm ring-1 ring-slate-200">
              <ReviewTab
                setSelectedTab={setSelectedTab}
                selectedTab={selectedTab}
                googleData={googleData}
                newData={newData}

              />   
              {selectedTab === 0 && (
              <div className="flex w-full justify-center px-5 pt-2">
                <Pagination
                  page={page}
                  count={totalPages}
                  shape="rounded"
                  color="primary" 
                  onChange={(event,value) => setPage(value)}
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontFamily: 'inherit',
                      fontWeight: 400,
                      borderRadius: '10px',
                      color: '#475569',
                    },
                    '& .MuiPaginationItem-root.Mui-selected': {
                      color: '#fff',
                      boxShadow: '0 1px 2px rgba(15, 23, 42, 0.12)',
                    },
                  }}
                />
              </div>
              )}       

            </div>
          </div>
          <div className="w-full space-y-5 lg:w-[32%]">
            <div className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200 sm:p-6">
              <SelfDescription data={data} />
            </div>
            <div onClick={() => setPopup(true)} className="flex cursor-pointer items-center justify-center gap-3 rounded-xl bg-[#1976d2] px-5 py-3 text-[15px] font-medium text-white shadow-sm transition duration-200 hover:-translate-y-0.5 hover:bg-[#1565c0] hover:shadow-md active:translate-y-0">
              <AiOutlineCalendar />
              {' '}
              <span className="text-[15px] font-medium">Request Appointment</span> 
            </div>
            <SimpleModal open={openPopup} setOpen={setPopup} modalWidth="800px">              
              <RequestAppointment data={data} baseURL={baseURL} setPopup={setPopup} />
            </SimpleModal>
            {data?.about_us === null ? (null) : (
              <div className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200 sm:p-6">
                <About data={data} />
              </div>
            )}
            <div className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200 sm:p-6">
              <AboutSalesCap />
            </div>
          </div>
          
        </div>
        
      </div>
    </div>

  );
};

export default ReviewProfile;
